import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../landingPage/home.module.css';

function PrivacyPolicy() {
  return (
    <>
      {/* Header */}
      <section className={`${styles.header} ${styles.headerCs}`}>
        <div className={`container ${styles.container}`}>
          <div className={styles.logo}>
            <Link to="/">
              <img src={window.getPublicUrl("/images/logo-2.svg")} alt="ResuMate Logo" />
            </Link>
          </div>
          <div className={styles.social}>
            <ul className='terms-list'>
              <li><a href=""><img src={window.getPublicUrl("/images/insta.svg")} alt="Instagram" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/fb.svg")} alt="Facebook" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/tik.svg")} alt="TikTok" /></a></li>
            </ul>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="privacy-container faq  terms-nd-condition" style={{ padding: '60px 0', minHeight: '70vh' }}>
  <div className={`container ${styles.container}`}>
        <header className="privacy-header">
          <h1 className='main-heading text-left'>ResuMate Privacy Policy</h1>
          <p>Last Updated: January 3, 2026</p>
        </header>
        <section className="privacy-content">
          <p>
            Welcome to ResuMate. Your privacy matters to us. This Privacy Policy explains how we
            collect, use, share, and protect your personal information when you use our mobile
            application (the “App”).
          </p>
          <p>
            By creating an account and using ResuMate, you agree to the practices described in this
            Policy. If you do not agree, please do not use our App.
          </p>
        </section>
        <article>
         <h2 className='inner-heading text-left'>1. Information We Collect</h2>

          <h3 className='child-inner'>a. Registration Information</h3>
          <p>When you create an account, we collect the following information you provide:</p>
          <ul className='terms-list'>
            <li>Name, email address, and mobile number</li>
            <li>Date of birth (must be 18+)</li>
            <li>Gender, sexual orientation, marital status, ethnic background</li>
            <li>Photos you choose to upload</li>
            <li>Location</li>
            <li>Height, religion or belief system, education history</li>
            <li>Dietary preferences, smoking and drinking habits, exercise level</li>
            <li>Kids status</li>
            <li>Other optional profile details you choose to provide</li>
          </ul>

           <h3 className='child-inner'>b. Profile Information (Your “Resume”)</h3>
          <ul className='terms-list'>
            <li>Answers to open-ended questions about your values, goals, and relationships</li>
            <li>AI-generated profile summaries created from your inputs</li>
            <li>Optional details you choose to include</li>
          </ul>

           <h3 className='child-inner'>c. Matching & Interaction Data</h3>
          <ul className='terms-list'>
            <li>Resume submissions to other users</li>
            <li>Whether submissions are accepted or declined</li>
            <li>Video call activity (date, time, duration)</li>
            <li>Feedback provided after calls</li>
            <li>Messages exchanged once mutual approval is granted</li>
          </ul>

           <h3 className='child-inner'>d. Device & Technical Information</h3>
          <ul className='terms-list'>
            <li>Device type and operating system</li>
            <li>Log data (IP address, app usage, error reports)</li>
            <li>Optional location information (if enabled)</li>
          </ul>

           <h3 className='child-inner'>e. Payment Information</h3>
          <ul className='terms-list'>
            <li>Payment details are processed solely by third-party providers (App Store, Google Play)</li>
            <li>ResuMate does not store your credit card or payment information</li>
          </ul>
        </article>

        <article>
         <h2 className='inner-heading text-left'>2. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul className='terms-list'>
            <li>Provide and improve the App and its features</li>
            <li>Generate AI-powered profile summaries</li>
            <li>Match you with compatible users</li>
            <li>Facilitate resume submissions, approvals, and private chat</li>
            <li>Enable secure video calls</li>
            <li>Ensure safety, detect fraud, and enforce our Terms of Use</li>
            <li>Communicate updates, security notices, and support responses</li>
            <li>Offer optional premium features</li>
          </ul>
          <p>
            <strong>AI Disclaimer:</strong> AI-generated summaries are for informational purposes only. 
            ResuMate does not guarantee their accuracy, completeness, or suitability, and users should 
            rely on their own judgment.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>3. Sharing of Information</h2>
          <ul className='terms-list'>
            <li>
              <strong>With Other Users:</strong> Profile and resume details you choose to provide
              may be visible to other users. Private details (email, phone number) are never shared.
            </li>
            <li>
              <strong>Service Providers:</strong> Trusted third parties may handle hosting,
              payments, analytics, or video calls.
            </li>
            <li>
              <strong>Legal & Safety Reasons:</strong> Information may be disclosed if required by
              law or to protect rights, safety, or security.
            </li>
            <li>
              <strong>Business Changes:</strong> If ResuMate is acquired, merged, or reorganized,
              data may transfer as part of that process.
            </li>
          </ul>
          <p>We do not sell your personal data to advertisers or third parties.</p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>4. Cookies & Tracking Technologies</h2>
          <p>
            We may use cookies, beacons, or similar technologies to:
          </p>
          <ul className='terms-list'>
            <li>Improve functionality and performance</li>
            <li>Analyze usage patterns</li>
            <li>Enable push notifications</li>
          </ul>
          <p>
            You can manage or disable cookies through your device or browser settings, though some
            features may not work as intended. We may also use trusted third-party analytics or 
            marketing partners to improve the service.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>5. Your Choices and Rights</h2>
          <p>You can exercise the following rights:</p>
          <ul className='terms-list'>
            <li>Access and receive a copy of your data</li>
            <li>Update or correct information</li>
            <li>Delete your account and data</li>
            <li>Restrict or object to certain data uses</li>
            <li>Withdraw consent for optional features</li>
          </ul>

           <h3 className='child-inner'>GDPR Users (EU/UK):</h3>
          <ul className='terms-list'>
            <li>
              Legal bases for processing include consent, contract performance, compliance with
              legal obligations, and legitimate interests.
            </li>
            <li>You may request data portability or lodge a complaint with your local authority.</li>
          </ul>

           <h3 className='child-inner'>CCPA Users (California):</h3>
          <ul className='terms-list'>
            <li>
              You have the right to request access, deletion, and disclosure of data collected in
              the past 12 months.
            </li>
            <li>We do not sell your personal information.</li>
          </ul>
          <p>
            To exercise any rights, contact us at <a className='email' href="mailto:info@resumate.org">info@resumate.org</a>.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>6. Data Retention</h2>
          <ul className='terms-list'>
            <li>If you delete your account, your profile will no longer be visible.</li>
            <li>Account data, resumes, messages, and personal information are deleted upon account deletion, except where retention is required for legal, safety, fraud prevention, or regulatory purposes.</li>
          </ul>
        </article>

        <article>
         <h2 className='inner-heading text-left'>7. Security</h2>
          <p>
            We implement industry-standard measures, including encryption and secure servers. However, no
            system is 100% secure, and we cannot guarantee absolute protection of your information.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>8. Data Breach Notification</h2>
          <p>
            In the event of a data breach, we will notify affected users and regulators as required by
            applicable law.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>9. Age Restriction</h2>
          <p>
            ResuMate is for individuals 18 years and older. We do not knowingly collect information
            from anyone under 18. If discovered, such data will be promptly deleted.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>10. International Users</h2>
          <p>
            Your information may be processed and stored outside your home country. We implement 
            appropriate safeguards, such as standard contractual clauses, to ensure your data is 
            adequately protected under applicable laws.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>11. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. If changes are significant, we will
            notify you in-app or by email. Continued use of the App constitutes acceptance of the 
            updated Policy.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>12. Governing Law & Dispute Resolution</h2>
          <p>
            This Policy is governed by the laws of the State of Arizona, USA. Any disputes shall
            first be attempted through informal resolution. If unresolved, disputes may be subject
            to arbitration or courts located in Maricopa County, Arizona, unless prohibited by law.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>13. Contact Us</h2>
          <address>
            Sparkle from Within LLC<br />
            4539 N 22nd St, Ste N, Phoenix, AZ 85016<br />
            <a className='email' href="mailto:info@resumate.org">info@resumate.org</a>
          </address>
        </article>
</div>
      </main>

      {/* Footer */}
      <section className={styles.footer}>
        <div className={`container ${styles.container}`}>
          <div className="row">
            <div className="col-sm-4">
              <div className={styles.footerLeft}>
                <a href=""><img src={window.getPublicUrl("/images/footer-logo.svg")} /></a>
              </div>
                      <div className={`${styles.footerMid} ${styles.right}`}>
                <h4>Follow us</h4>
                <ul className='terms-list'>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social1.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social2.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social3.svg")} /></a></li>
                </ul>
              </div>

            </div>
            <div className="col-sm-4">
                      <div>
                <ul className={styles.termsConditonList}>
                  <li><Link to="/terms&condition">Terms & Conditions</Link></li>
                  <li><Link to="/privacyPolicy">Privacy Policy</Link></li>
                  <li><Link to="/communityGuidelines">Community Guidelines</Link></li>
                  <li><Link to="/eula">EULA</Link></li>
                  <li><Link to="/safety">Safety</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-sm-4">
                  <div className={styles.footerMid}>
                <h4 className="text-right">Get the app</h4>
                <ul className="text-right">
                  <li><a href="https://apps.apple.com/us/app/resumate-app/id6754164064
"><img src={window.getPublicUrl("/images/app2.svg")} /></a></li>
                  <li><a href="https://play.google.com/store/apps/details?id=com.resumate"><img src={window.getPublicUrl("/images/goog2.svg")} /></a></li>                </ul>
              </div>

            </div>
            <div className="col-sm-12">
              <h5>© 2026 ResuMate. All rights reserved.</h5>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;
